import ReactMarkdown, { Options } from 'react-markdown';
import { COMPONENTS } from './CustomComponents';

export const Markdown = ({ children }: Options) => {
  return <ReactMarkdown components={COMPONENTS}>{children}</ReactMarkdown>;
};
